import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
// import generalFunc from "../Utils/generalFunc"; 


const systemSettingsBaseController = "api/settings";

export const saveSystemSettingsApi = async (body) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${systemSettingsBaseController}/save-system-settings`, body);
      toastr.success('Settings Saved', 'Success')
      return response
    }
  } catch (error) {
    toastr.error('Error Saving Settings', 'Please try again')
    throw error;
  }
}

export const getSystemSettingsApi = async () => {
  try {
    if (navigator.onLine) {
      const response = await api.get(`${systemSettingsBaseController}/get-system-settings`);
      return response
    }
  } catch (error) {
    toastr.error('Error Fetching Settings', 'Please try again')
    throw error;
  }
} 